var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tiltPhone"},[_c('div',{staticClass:"tiltPhone__content"},[_c('icon-tilt'),_vm._v(" "),_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffd85bf0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TiltPhone.vue
// module id = 62
// module chunks = 0